module.exports = __webpack_public_path__ + "img/product_44.afdc66c.svg";